import React from 'react'
import Top from './Top'
import VFooter from './VFooter'
import { Card } from './ui';

export default function PaymentShipping() {
  return (
    <div>
      <Top/>
            {/* Main Content */}
      <main className="pt-10">
        <section className="py-16 px-5 bg-[#f4ece5] text-[#333] font-sans">
          <div className="max-w-4xl mx-auto p-8 bg-white rounded-lg shadow-md">
            <h2 className="text-center mb-8 text-3xl font-bold italic">Payments and Shipping</h2>
            
            <div className="p-4">
              <p className="text-xl font-semibold mb-4">Payment Process:</p>
              <ul className="list-disc pl-5 space-y-4">
                <li>
                  <strong>How Payments Work:</strong> After a user receives their product, a 3% fee will be deducted from the total order price. The remaining amount will be sent directly to your bank account within 7 working days.
                </li>
                <li>
                  <strong>Payment Methods:</strong> Users can pay securely through various methods, including credit/debit cards and digital wallets.
                </li>
                <li>
                  <strong>Transaction Security:</strong> We utilize secure payment systems to keep all transactions safe. Your financial details will not be stored on our servers.
                </li>
              </ul>

              <p className="text-xl font-semibold mt-12 mb-4">Shipping Information:</p>
              <ul className="list-disc pl-5 space-y-4">
                <li>
                  <strong>Shipping Responsibilities:</strong> Currently, Vasstr does not manage shipping. You will need to handle the packaging and shipping of orders to users directly.
                </li>
                <li>
                  <strong>Shipping Costs:</strong> You can set any shipping fees and communicate them to users before the order is finalized.
                </li>
                <li>
                  <strong>Delivery Timeline:</strong> Provide users with an estimated delivery time based on how long it will take you to create the product and the shipping method you choose.
                </li>
                <li>
                  <strong>Order Tracking:</strong> When you ship an order, provide tracking information to users so they can follow their package.
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
      <VFooter/>
    </div>
  )
}
